import * as ActionTypes from '../constants/ActionTypes';

function addTheme(theme) {
    return { type: ActionTypes.MANAGE_THEME_ADD_THEME, theme: theme };
}

function addConfig(config) {
    return { type: ActionTypes.MANAGE_CONFIG_ADD_CONFIG, configuration: config };
}

function setThemeLevel(level) {
    return { type: ActionTypes.MANAGE_THEME_MODAL_SET_THEME_LEVEL, themelevel: level };
}

function setThemeStatus(theme, status) {
    return { type: ActionTypes.MANAGE_THEME_SET_THEME_STATUS, theme: theme, status: status };
}

function deleteElement(item) {
    return { type: ActionTypes.MANAGE_DELETE_ITEM, item };
}

function setDefaultTheme(item) {
    return { type: ActionTypes.MANAGE_SET_DEFAULT_THEME, item };
}

export { addTheme, addConfig, setThemeLevel, setThemeStatus, deleteElement, setDefaultTheme };



// WEBPACK FOOTER //
// ./src/actions/manage.js